import { useQuery } from "@tanstack/react-query";

import { api, type ExpertSignupPrefill } from "@/services/api";

/**
 * The signed-in Expert's CRM record for prefilling signup steps 2-4, or null.
 * One fetch shared by all three steps; a missing record or a failed request
 * both read as null, so prefill never blocks the forms.
 */
export const useExpertSignupPrefill = (enabled: boolean) =>
  useQuery<ExpertSignupPrefill | null>({
    queryKey: ["crm-expert-signup-prefill"],
    queryFn: () => api.crmLeads.getMyExpertPrefill().catch(() => null),
    enabled,
    staleTime: Infinity,
    retry: false,
  });
